import { render, staticRenderFns } from "./pageListOld.vue?vue&type=template&id=45c60044&scoped=true&"
import script from "./pageListOld.vue?vue&type=script&lang=js&"
export * from "./pageListOld.vue?vue&type=script&lang=js&"
import style0 from "./pageListOld.vue?vue&type=style&index=0&id=45c60044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c60044",
  null
  
)

export default component.exports